<template>
    <main :class="displayClass + ' pt-4'">
        <!-- <bs-page-title :titleLabel="'info'" :btnLabel="''"></bs-page-title> -->
        <div class=" mb-5">
            <h3 class="text-center my-3 py-2 bg-info">Message</h3>
            <div class="row mb-4">
                <div class="col-3 col-sm-2 ">
                    <div class="text-center">
                        <img src="@/assets/dummy_staff_m.png" class="w-100">
                    </div>
                    <p class="text-center">
                        <label class="badge bg-primary">STAFF</label>
                    </p>
                </div>
                <div class="col-9 col-sm-10 ">
                    <p class="border rounded py-2 px-2">
                        abc
                    </p>
                </div>
            </div>
            <div class="row mb-4">
                <div class="col-9 col-sm-10 ">
                    <p class="border rounded py-2 px-2">
                        abc
                    </p>
                </div>
                <div class="col-3 col-sm-2 ">
                    <div class="text-center">
                        <img src="@/assets/dummy_car_002.jpg" class="w-100">
                    </div>
                    <p class="text-center">
                        <label class="badge bg-success">曲川太郎</label>
                    </p>
                </div>
            </div>
        </div>
        <div class=" mb-5">
            <div class="">
                <a href="#" class="btn btn-light btn-outline-secondary d-block">読み込み</a>
            </div>
        </div>
    </main>
</template>

<script>
// import BsPageTitle from '../molecules/BsPageTitle.vue'

export default {
    name: 'BsDashBoardView',
    data: function () {
        return {
            'tab_active': 'drive',//or th ead
        }
    },
    props: {
        displayClass: {
            type: String,
            default: 'col-md-9 ms-sm-auto col-lg-10 px-md-4'
        },
    },
    components: {
        // BsPageTitle,
    },
    methods: {
        tab_switch_action(tab) {
        this.tab_active = tab;
        },
    },
    computed: {
        tabDisplay: function () {
        const self_tab_active = this.tab_active;
        return function (tab) {
            let tabClass = 'd-none ';
            if(self_tab_active == tab){
            tabClass = 'd-block';
            }
            return tabClass;
        }

        },
        tab_switch: function() {
        const self_tab_active = this.tab_active;
        return function (tab) {
            let tabClass = 'nav-link ';
            console.log('tab_switch', self_tab_active);
            if(self_tab_active == tab){
            tabClass += 'active';
            }
            return tabClass;
        }
        },
    }
}
</script>
